import request from "@/utils/request";

// 列表(主数据列表)
export function loadReceiveVoucherListDataApi(data) {
  return request({
    url: "web/receiveVoucher/listData",
    method: "post",
    data
  });
}
// 导出
export function loadReceiveVoucherExportDataApi(data) {
  return request({
    url: "web/receiveVoucher/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateReceiveVoucherApi(data) {
  return request({
    url: "web/receiveVoucher/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initReceiveVoucherApi(data) {
  return request({
    url: "web/receiveVoucher/init",
    method: "post",
    data
  });
}

// 待处理数量
export function countReceiveVoucherTodoNumberApi(data) {
  return request({
    url: "web/receiveVoucher/countTodoNumber",
    method: "post",
    data
  });
}
